import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Project } from '../../../project/models/project';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { FormValidationService } from '../../../../shared/services/form-validation.service';

@Component({
  selector: 'app-train-type-create',
  template: require('./train-type-create.component.html'),
  styles: [require('./train-type-create.component.sass')]
})
export class TrainTypeCreateComponent implements OnInit {
  
  @ViewChild('trainTypeCreateModal') trainTypeCreateModal: ElementRef;
  
  @Input() projects: Project[];
  @Input() existingTrainTypes: string[];

  @Output() createTrainType = new EventEmitter<{
    project: Project,
    trainType: string
  }>();

  selectedProjectId: number;
  trainType: string;
  trainTypeForm: FormGroup;

  trainTypeCreateModalReference: NgbModalRef;


  constructor(
      private fb: FormBuilder,
      private modalService: NgbModal,
      public formValidation: FormValidationService
  ) {
    this.trainTypeForm = this.fb.group({
      name: ['', Validators.required],
      trainType: ['', Validators.required]
    })
  }

  ngOnInit(): void {
  }

  async showModal(projectId: number) {
    this.selectedProjectId = projectId;
    this.trainTypeForm.reset();
    this.trainTypeCreateModalReference = await this.modalService.open(this.trainTypeCreateModal, {
      size: 'lg',
      backdrop: 'static'
    });
  }

  create = () => {
    const selectedProject = this.projects.find(project => project.id === this.selectedProjectId);

    if (this.trainTypeForm.valid && selectedProject) {

      this.createTrainType.emit({
        project: selectedProject,
        trainType: this.trainTypeForm.value && this.trainTypeForm.value.trainType
      });
      this.trainTypeCreateModalReference.close();
    }

  else{
      this.formValidation.validateAllFormFields(this.trainTypeForm);
    }
  }


}
